module.exports = __webpack_public_path__ + "static/media/7ICJ1.8f888883.jpg";